import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllCollectionTypes(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/calculation_types/`,
    oauthTokenHeader
  );
}

function createCollectionTypes(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/calculation_types/`,
    data,
    oauthTokenHeader
  );
}

function updateCollectionTypes(
  oauthTokenHeader: string,
  data: any,
  collectionTypeId: any
) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/calculation_types/${collectionTypeId}/`,
    data,
    oauthTokenHeader
  );
}
export const calculationTypesService = {
  getAllCollectionTypes,
  createCollectionTypes,
  updateCollectionTypes,
};
